export const buildAlgoliaFacets = (facets, nullable = false) => {
  const facetsWithActiveFilters = facets.filter(facet => facet.values.length > 0)
  const params = {
    facets: [...facets.map(facet => facet.key)],
    filters: facetsWithActiveFilters.map(facet => buildFilters(facet)).join(' OR '),
  }
  if (!params.filters && nullable) params.filters = []
  return params
}

const buildFilters = facet => {
  let str = ''
  if (facet.values[0] === 'all') return
  facet.values.forEach((value, index) => {
    str += `'${facet.key}':'${value}'${index + 1 === facet.values.length ? '' : ' OR '}`
  })
  return str
}
